/* global $ */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import modalUtils from '../../../../../../../qti/utils/ModalUtils';
import stringUtils from '../../../../../../../qti/utils/StringUtils';
import MathEntryInput from './MathEntryInput';
import { t } from '../../../../../../../services/i18nService';

import styles from './mathEntryTool.scss';

class MathEntryToolModal extends React.Component {
    static propTypes = {
        mathSymbolPalettePreset: PropTypes.object,
        mathElement: PropTypes.object,
        ckeditor: PropTypes.object.isRequired, // the ckeditor instance
        closeCallback: PropTypes.func.isRequired,
    };

    getMathEntryModel() {
        if (!this.mathEntryModel) {
            this.mathEntryModel = {
                identifier: stringUtils.getUID(),
                autoFocus: true,
            };
        }
        return this.mathEntryModel;
    }

    getInputValue() {
        return this.inputComponentInstance.getValue();
    }

    onInsertClick = () => {
        const { closeCallback, ckeditor } = this.props;
        let mathEntryValue = this.getInputValue();
        if (mathEntryValue && mathEntryValue.length) {
            // Replace double quotes with single quotes as the double ones create problems for CKEditor when
            // storing the LaTeX as attribute
            mathEntryValue = mathEntryValue.replace(/"/g, "'");
        }
        const mathjaxTemplate =
            $(`<span class="math-tex"
                     id="math-tex-${stringUtils.getUID()}"
                     style="display:inline-block"
                     data-cke-survive=1
                     data-mathEntryValue="${mathEntryValue}"></span>`)[0];
        const ckElement = new window.CKEDITOR.dom.element(mathjaxTemplate); // eslint-disable-line new-cap
        const ranges = ckeditor.getSelection().getRanges();
        const savedSelection = ranges.length ? ranges[0] : undefined;

        try {
            ckeditor.insertElement(ckElement, savedSelection);
        } catch (e) {
            console.error('Error inserting math into CKEditor', e);
        }

        setTimeout(() => {
            ckeditor.widgets.initOn(ckElement, 'mathjax');
            ckeditor.widgets.getByElement(ckElement).setData('math', `\\(${mathEntryValue}\\)`);
            // CKEditor plugin handles math render in iframe
            // MathJax2Display.showMathJax2(ckeditor.editable().$);

            closeCallback();
        }, 200);
    };

    onCloseClick = () => {
        this.props.closeCallback();
    };

    render() {
        const { mathElement, mathSymbolPalettePreset } = this.props;
        return (
            <Modal
                contentLabel="Math entry"
                isOpen
                style={modalUtils.mathEntryModalStyles}
            >
                <div className={styles.mathEntryToolWrapper}>
                    <div className={styles.wrapper}>
                        <div className={styles.headerContainer}>
                            <div className={styles.header}>
                                <span className="title" role="heading">{t('ckeditor.mathEditor.header')}</span>
                            </div>
                            <div className={styles.toolbar}>
                                <button
                                    className="modalButton modalButtonClose"
                                    onClick={this.onCloseClick}
                                >
                                    {t('general.cancel')}
                                </button>
                                <button
                                    className="modalButton modalButtonUpdate"
                                    onClick={this.onInsertClick}
                                >
                                    {t('general.done')}
                                </button>
                            </div>
                        </div>
                        <div className={styles.mainContainer}>
                            <MathEntryInput
                                mathSymbolPalettePreset={mathSymbolPalettePreset}
                                model={this.getMathEntryModel()}
                                defaultValue={mathElement ? mathElement.getAttribute('data-mathEntryValue') : ''}
                                isReadOnly={false}
                                maxLength={100}
                                ref={(instance) => { this.inputComponentInstance = instance; }}
                                size={50}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default MathEntryToolModal;
